module.exports = __webpack_public_path__ + "img/直播banner05.20306b57.png";